var link_viewer_wrapper_default = {
  "anchor": "Vj1Au",
  "link": "FxLkP"
};
export {
  link_viewer_wrapper_default as default
};
//# sourceMappingURL=link-viewer-wrapper-scss.js.map
